import React, { ComponentType } from 'react'
import { Popover } from 'antd'
import { AccessRestrictionParams, resolveAccessRestriction } from './accessRestriction'

type WithDisabled = { disabled?: boolean }

/**
 * Оборачивает любой antd-контрол с prop'ом disabled (Select, Input, InputNumber, DatePicker...)
 * так, чтобы вызывающему коду не нужно было ни оборачивать его в JSX, ни отдельно
 * проставлять disabled — оба решения принимаются здесь, на основе resolveAccessRestriction.
 */
export function withAccessRestriction<P extends WithDisabled>(Component: ComponentType<P>) {
  return ({ plan, checkBlackMark, disabled, ...rest }: P & AccessRestrictionParams) => {
    const { restricted, title } = resolveAccessRestriction({ plan, checkBlackMark })

    const element = <Component {...(rest as P)} disabled={restricted || disabled} />

    if (!restricted) {
      return element
    }

    // disabled-элемент не генерирует mouse-события, поэтому Popover, навешенный
    // прямо на него, никогда не увидит hover — оборачиваем в обычный span,
    // как это делает сам antd для disabled Button с Tooltip.
    return (
      <Popover placement="bottom" title={title}>
        <span style={{ cursor: 'not-allowed' }}>
          {element}
        </span>
      </Popover>
    )
  }
}
